export default __webpack_public_path__ + "static/media/Hooch_Booch_Neon_Final.27620c4a.gif";